<template>
    <div>
        <!--<h1>{{ user.firstName }} {{ user.name }}</h1>-->
        

        <div id="formMdp" v-if="!errorActive && !errorDate && !errorGet">

            <h1 v-if="activationData.type== 1">Modification du mot de passe</h1>
            <h1 v-else>Activer mon compte</h1>

            <!--
            <h2 v-if="activationData.type== 1">Reinitialisé mon mot de passe :</h2>
            <h2 v-else>Créer mon mot de passe :</h2>
            -->
            <br/>

            <label v-if="activationData.type== 1">Veuillez saisir votre nouveau mot de passe :</label>
            <label  v-else>Veuillez saisir votre mot de passe :</label>
            <div class="form_row" >
                <input v-model="new_pass1" class="form_input" type="password" placeholder="Mot de passe" name='newPass' :disabled="mdpchange"/>
            </div>

            <label v-if="activationData.type== 1">Veuillez confirmer votre nouveau mot de passe :</label>
            <label  v-else>Veuillez confirmer votre mot de passe :</label>
            <div class="form_row" >
                <input v-model="new_pass2" class="form_input" type="password" placeholder="Confirmation du mot de passe" name='newPass' :disabled="mdpchange" />
            </div>

            <button v-if="!mdpchange" class="form_button" :class="{'form_button_disabled' : (!canChangeMDP())}" :disabled="!canChangeMDP()" @click="sendChangeMDP()">
                <span v-if="activationData.type== 1">Reinitialiser mon mot de passe</span>
                <span v-else >Créer mon mot de passe</span>
            </button>
        </div>
        <br/>
        <div id="errorbackground" v-if="errorDate || errrorActive || errorGet">

            
            <div v-if="errorDate" id="errorDate" class="red panel">
                <div class="error_icon material-icons">error</div>
                <div id="expire" class="result">Votre lien est expiré, </div>
                <br/>
                <div class="result contactAdmin">veuillez contacter votre administrateur pour qu’il le réinitialise.</div>
            </div>

            
            <div v-if="errorActive" id="errorActive" class="red panel">
                <div class="error_icon material-icons">error</div>
                <div id="used" class="result">Votre lien a déjà été utilisé, vous pouvez vous connecter avec votre adresse mail et votre mot de passe sur le portail de ProLexis WebService.</div>
                <br/>
            </div>

            <div v-if="errorGet" id="errorGet" class="red panel">
                <div class="error_icon material-icons">error</div>
                <div id="internal" class="result">Nous sommes désolés, une erreur est survenue.<br/><br/> Merci de vous reconnecter ultérieurement ou de contacter Diagonal.</div>
            </div>
            
        </div>


        <div v-if="mdpchange && !errorGet" class="green">
            
            <div id="thanks" class="result">
                <span v-if="activationData.type== 1">Merci, votre mot de passe a bien été modifié</span>
                <span v-else>Merci, votre mot de passe a bien été créé</span>
            </div>
            <div id="gologin" class="result"><router-link  class="lienActif" to="/login">Retourner sur la page de login pour vous connecter</router-link></div>
        </div>
        

    </div>
</template>

<script>
    import axios from 'axios'
    import { diagonalbackURL, defaultConfig } from "../constantes";
    import FctUtils from '@/components/FctUtils';

    export default { 
        name:"Activation",
        components: { },
        mixins: [FctUtils],
        data() {
            return {
                user:{},
                new_pass1:"",
                new_pass2:"",
                activationData: {},
                errorGet:false,
                errorDate: false,
                errorActive: false,
                mdpchange : false,
            }
        },
        created() {
            console.log("coucou : "+this.$route.query.code);

            if (this.$route.query.code != undefined) {
                axios(diagonalbackURL + "/users/activation/"+ this.$route.query.code,  defaultConfig)
                .then(reponse => {
                    this.activationData = reponse.data;

                    if (this.activationData) {
                        
                        if (!this.activationData.active) {
                            this.errorActive = true;
                        }
                        else if (Date.now() >= this.activationData.expire * 1000) {
                            this.errorDate = true;
                        }


                        /*
                        if (!this.errorActive && !this.errorDate) {
                            axios(diagonalbackURL + "/users/" + this.activationData.userId,  defaultConfig)
                            .then(reponse => this.user = reponse.data)
                            .catch(error => {
                                //this.errorGet = true;
                                this.errorHandler(error)
                            });            
                        }*/
                    }

                    console.log("Activation Data : ", this.activationData)
                })
                .catch(error => {
                    this.errorGet = true;
                    this.errorHandler(error)
                });
            }
        },
        methods : {
            canChangeMDP() {
                return this.new_pass1 != "" && this.new_pass1 == this.new_pass2 && !this.mdpchange;
            },
            sendChangeMDP() {
                const params = JSON.stringify({
                    'password':this.new_pass1,
                });
                
                axios.post(diagonalbackURL + "/users/activation/"+this.activationData.code, params, defaultConfig)
                .then(reponse => {
                    this.mdpchange = true;
                    //this.$router.go();
                })
                .catch(error => this.errorHandler(error));   
            }
        }
    }
</script>

<style scoped>
    #content {
        overflow: hidden;
    }

    #formMdp .form_row {
        margin-top : 8px;
    }

    #errorbackground {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
        background-color: #88888870;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .panel {
        position: relative;
        background-color: #fff;
        width: 540px;
        max-width: 100%;
        border-radius: 16px;
        padding: 32px;
    }

    #errorGet {
        width: 510px;
        display: none;
    }

    #errorActive {
        width: 570px;
        display: none;
    }

    #errorDate {
        width: 570px;
        
    }

    #errorDate .contactAdmin {
        width: 470px;
    }

    .result {
        font-size: 18px;
        margin: 0 auto;
        width: 50%;
        padding-left: 20%;
    }

    .error_icon {
        width: 20%;
        float: left;
        font-size: 65px;
    }

    #thanks {
        display: inline-block;
        margin-top: 10px;
        text-align: center;
        padding-left: 0;
    }

    #gologin {
        display: inline-block;
        text-align: center;
        padding-left: 0;
    }

    .contactAdmin {
        width: 375px;
    }

    #expire {
        width: 160px;
    }

    #used {
        width: 450px;
    }

    #internal {
        width: 380px;
    }
    
</style>